<template>
    <div class="container wrapper" :class="[
                state.fadeClass,
                state.visibilityClass,
                state.mouseClass
            ]">
        <div class="split">
            <div id="ChoiceButtons">
                <!-- Empty divs are used as containers for the conversation triangles. -->
                <div :class="{ highlight: state.progress == 0 }"></div>
                <div :class="{ highlight: state.progress == 2 }"></div>
                <div :class="{ highlight: state.progress == 1 }"></div>
                <div :class="{ highlight: state.progress == 3 }"></div>
                <div v-if="state.progress < 4" id="decks">
                    <div v-if="state.progress <= 1" class="choice global-hover" @click="chooseCardType('Haaste')">
                        <img src="../assets/cardStack.png" alt="ValintaPakka">
                        <p>Haaste</p>
                    </div>
                    <div v-if="state.progress <= 1" class="choice global-hover" @click="chooseCardType('Toive')">
                        <img src="../assets/cardStack.png" alt="ValintaPakka">
                        <p>Toive</p>
                    </div>
                    <div v-if="state.progress <= 1" class="choice global-hover" @click="chooseCardType('Ongelma')">
                        <img src="../assets/cardStack.png" alt="ValintaPakka">
                        <p>Ongelma</p>
                    </div>
                     <div v-if="state.progress > 1" class="choice global-hover" @click="chooseCardType('Voimavara')">
                        <img src="../assets/cardStack.png" alt="ValintaPakka">
                        <p>Voimavara</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="split">
            <div class="trigenda-wrapper">
                <div id="trigendaBoard">
                    <img id="tausta" class="triangle" src="../assets/Alusta_tumma.png">
                    <div v-if="state.progress >= 1">
                        <img class="triangle" src="../assets/card.png">
                        <h1>
                            {{ state.cards.target }}
                        </h1>
                    </div>
                    <div v-if="state.progress >= 2">
                        <img class="triangle" src="../assets/card.png">
                        <h1>
                            {{ state.cards.challenge }}
                        </h1>
                    </div>
                    <div v-if="state.progress >= 3">
                        <img class="triangle" src="../assets/card.png">
                        <h1>
                            {{ state.cards.asset1 }}
                        </h1>
                    </div>
                    <div v-if="state.progress >= 4">
                        <img class="triangle" src="../assets/card.png">
                        <h1>
                            {{ state.cards.asset2 }}
                        </h1>
                    </div>
                </div>
            <div id="tips">
            <p><span class="bold">Tavoite-sektori: </span>Tämä on keskustelun pääteema eli aihe, jota keskustelun avulla lähdetään avaamaan ja johon lähdetään miettimään konkreettisia tavoitteita.</p>
            <p><span class="bold">Haaste-sektori: </span>Haaste-sektorin tarkoituksena on syventää valittua pääteemaa. Tähän sektoriin saat valita jonkin käsitekortin, joka olennaisesti liittyy Tavoite-sektoriin valittuun käsitteeseen. Valittu asia  haastaa tavoitteisiin pääsyä tai tavoitteiden toteutumista.</p>
            <p><span class="bold">Voimavara-sektorit: </span>Näihin sektoreihin valitset kaksi tavoitteeksi valitun käsitteen kannalta tärkeintä voimavaraa, jotka auttavat tavoitteen saavuttamisessa.</p>
            </div>
        </div>
            <!-- Show "Next stage" button if state.overlayIsActive is set to false -->
            <Tip v-if="!state.backToStart && props.showInfo" :tipMsg="state.tipMsg[state.progress]" :mood="state.tipMood" />
        </div>

        <!-- Overlay is a component where card selection and answer choices are
        made for a current card placeholder shown in Phase2 component. Overlay is shown over the
        Phase2 component and Phase2 is shown transparent behind the Overlay.
        -->
        <Overlay v-if="state.overlayVisibility"
            :cardType="state.overlayCardType"
            :selectionType="state.selectionType"
            @deactivateOverlay="deactivateOverlay"
            @phasecomplete="finishPhase"
            @goBack="goBack" />
    </div>
</template>

<script>

import Card from "./Card.vue";
import Answer from "./Answer.vue";
import Overlay from "./Overlay.vue";
import Tip from './Tip.vue';
import { reactive } from "vue";
import Summary from './Summary.vue';

export default {
    name: "Phase2",
    props: {
        msg: String,
        showInfo: Boolean
    },
    components: {
        Card,
        Answer,
        Overlay,
        Tip,
        Summary
    },
    setup(props, { emit } ) {

        const state = reactive({
            // Fade effect CSS class for Container div. ('fadeIn' or 'fadeOut')
            fadeClass: null,
            // Visibility CSS class for Container div. ('visible' or 'hidden')
            visibilityClass: 'hidden',

            /**
             * Mouse CSS class for Container div,
             * tells if mouse clicks are enabled or disabled. ('mouseEnabled' or 'mouseDisabled')
             */
            mouseClass: 'mouseDisabled',
            // Overlay is shown or hidden based on state.overlayVisibility boolean value.
            overlayVisibility: false,
            // OverlaycardType tells what kind of cards are shown in Overlay's CardSelection component.
            overlayCardType: null,
            // SelectionType tells where the card will be placed in Trigenda triangle.
            selectionType: null,

            /**
             * SelectionType, Tringo's message are set based on progress index. The "Next Phase"
             * button is shown if progress is 4.
             */
            progress: 0,
            cardArray: JSON.parse(localStorage.getItem("cardArray")),
            cards: {target: '', challenge: '', asset1: '', asset2: ''},
            // Tringo's messages. Strings separated by comma in the arrays creates a line break in the message.
            tipMsg: [
                ['Hienoa! Nyt olet suorittanut ensimmäisen vaiheen ja siirrymme toiseen vaiheeseen. Seuraavaksi on aika valita Trigenda® keskustelun aiheet. Keskustelu alkaa vasta, kun Trigenda® keskusteluun on valittu kaikki aiheet. Valitse ensin osa-alue, sen jälkeen valitse keskusteluun pääteema, josta haluat puhua. Pääteemasta tulee keskusteluun tavoite.'],
                ['Onnistuit! Nyt on tulevaan keskusteluun valittu tavoite. Seuraavaksi saat valita haasteen, joka liittyy tavoite-sektoriin valittuun aiheeseen. Etsi käsitekorteista jokin käsite, joka haastaa tavoitteen toteutumista ja tavoitteen saavuttamista.',
                    'Voit etsiä sopivaa käsitekorttia haaste, toive ja ongelma -korttipakkojen lisäksi myös edellisen vaiheen “en osaa sanoa “-korttipakasta.'],
                ['Nyt keskustelun runkoon on löytynyt tavoite sekä haaste. Seuraavaksi saat valita voimavarat, jotka tukevat sinua juuri näiden valittujen tavoitteen sekä haasteen kanssa. Valitse ensimmäinen voimavara tunnistamistasi voimavara-korteista.'],
                ['Ensimmäinen tärkeä voimavara löydetty. Valitse vielä toinen voimavara-kortti. Tämän jälkeen, kun molemmat voimavarat on löydetty, siirrytään keskustelemaan valituista teemoista ja näin alkaa työskentelyn kolmas vaihe.'],
            ],
            // Sets the mood of Tringo, passed to Tip component. 'happy', 'confused' or 'sad'
            tipMood: 'happy',
        });

        const fadeInElements = () => {
            state.fadeClass = 'fadeIn';
            state.visibilityClass = 'visible';
            setTimeout(() => {
                state.mouseClass = 'mouseEnabled';
            }, 200);
        }

        fadeInElements();

        const activateOverlay = () => {
            state.overlayVisibility = true;
        }

        const deactivateOverlay = () => {
            // In order to display card names we need to update cardArray list
            state.cardArray = JSON.parse(localStorage.getItem("cardArray"))
            // After updating we need to update the name variables
            getCardName()

            state.overlayVisibility = false;
            state.progress++;

            if (state.progress === 4)
                finishPhase();
        }

        const getCardName = () => {
            if(state.progress === 0)
                state.cardArray.forEach(item => {
                    if(item.phase2selection === 'Tavoite')
                        state.cards.target = item.description
                })

            else if(state.progress === 1)
                state.cardArray.forEach(item => {
                    if(item.phase2selection === 'Haaste')
                        state.cards.challenge = item.description
                })

            else if(state.progress === 2)
                state.cardArray.forEach(item => {
                    if(item.phase2selection === 'Voimavara1')
                        state.cards.asset1 = item.description
                })

            else if(state.progress === 3)
                state.cardArray.forEach(item => {
                    if(item.phase2selection === 'Voimavara2')
                        state.cards.asset2 = item.description
                })
        }

        const finishPhase = () => {
            emit("phasecomplete");
        }
        const chooseCardType = (cardType) => {
            state.overlayCardType = cardType;

            if (state.progress === 0)
                state.selectionType = "Tavoite"

            else if (state.progress === 1)
                state.selectionType = "Haaste"

            else if (state.progress === 2)
                state.selectionType = "Voimavara1"

            else if (state.progress === 3)
                state.selectionType = "Voimavara2"

            activateOverlay();
        }
        const goBack = () => {
            state.overlayCardType = null;
            state.selectionType = null;
            state.overlayVisibility = false;
        }
        return { activateOverlay, state, deactivateOverlay, finishPhase, chooseCardType, goBack, props };
    },
    emits: ['phasecomplete'],
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .container{
        overflow-x: hidden;
    }
    .wrapper {
        display: flex;
        height: 90vh;
    }

    .split {
        width: 50%;
        height: 90vh;
        justify-content: center;
        margin: auto 0;
    }
    .split:nth-child(2) {
        background-image: url('../assets/tausta_blue.jpg');
        background-size: cover;
        background-repeat: no-repeat;
    }
    .split:first-child {
        background-color: var(--left);
    }

    .split:nth-child(2) .content {
        margin-top: 170px;
    }
    .choice{
        width: 80%;
        height: 80%;
    }
    .choice > img{
        width: 80%;
    }

    p {
        margin:0;
    }

    #tips{
        text-align:left;
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        overflow-y: auto;
        height: 150px;
    }

    #decks{
        display: inline-flex;
    }

    #ChoiceButtons{
        margin-top: 15em;
    }

    .trigenda-wrapper {
        margin-top: 16%;
    }

    #trigendaBoard{
        position: relative;
        transform: translate(160px, -20px) scale(1.00);
        width: 459px;
        height: 400px;
        margin: 30px auto;
        display: flex;
        flex-wrap: wrap;
    }

    #trigendaBoard div {
        padding: 10px;
        width: 90px;
        height: 100px;
        margin: auto;
        transform: scale(1.17);
    }

    #trigendaBoard div h1 {
        font-size: 16px;
        font-weight: normal;
        font-family: Lato;
        text-align: center;
        width: 150px;
    }

    #trigendaBoard :nth-child(1) {
        width: 100%;
        margin: auto;
        padding: 0 30px;
    }

    #trigendaBoard :nth-child(1) {
        z-index: 10px;
        transform: translateY(0px) translateX(-220px) scale(1.0);
    }

    #trigendaBoard :nth-child(2) {
        transform: translateY(22px) translateX(-100px);
        position: absolute;
    }

    #trigendaBoard :nth-child(2) img {
        transform: translateY(0px) translateX(0px) scale(1.35);
    }

    #trigendaBoard :nth-child(3) {
        transform: translateX(-99px) translateY(240px);
        position: absolute;
    }

    #trigendaBoard :nth-child(3) img {
        transform: rotate(180deg) translateY(0px) translateX(0px) scale(1.35);
    }

    #trigendaBoard :nth-child(4) {
        transform: translateY(235px) translateX(-221px);
        position: absolute;
    }

    #trigendaBoard :nth-child(4) img {
        transform: translateY(0px) translateX(0px) scale(1.35);
    }

    #trigendaBoard :nth-child(5) {
        transform: translateY(235px) translateX(22px);
        position: absolute;
    }

    #trigendaBoard :nth-child(5) img {
        transform: translateY(0px) translateX(0px) scale(1.35);
    }

    #trigendaBoard :nth-child(3) h1 {
        transform: translateY(-20px) translateX(55px) scale(0.7);
    }

    #trigendaBoard :nth-child(5) h1, #trigendaBoard :nth-child(4) h1, #trigendaBoard :nth-child(2) h1 {
        transform: translateY(75px) translateX(55px) scale(0.7);
    }

    .triangle {
        position: absolute;
    }
    .triangle2{
        background-color: white;
    }
   @media only screen and (max-width: 735px) {
        .wrapper {
            flex-direction: column;
        }

        .split {
            width: 100%;
        }
        .wrapper {
            height: 91vh;
        }

        .split:nth-child(2) .content {
            margin-top: 0px !important;
        }

        #trigendaBoard {
            margin-top: 5px;
            margin-bottom: 10px;
            transform: scale(1) translate(200px, 25px);
        }
    }
        @media only screen and (max-width: 1000px) {
        .trigenda-wrapper {
            transform: scale(0.8);
        }
    }
        @media only screen and (max-width: 850px) {
        .trigenda-wrapper {
            transform: scale(0.6);
        }
    }

      /*
      Mobile media points -> translateX for board position -> Button margin-left for button position
      */


    @media only screen and (max-width: 480px) {
        .trigenda-wrapper {
            transform: scale(0.6) translateX(-2vw);
        }
    }
        @media only screen and (max-width: 400px) {
        .trigenda-wrapper {
            transform: scale(0.6) translateX(-10vw);
        }
    }
        @media only screen and (max-width: 360px) {
        .trigenda-wrapper {
            transform: scale(0.6) translateX(-15vw);
        }
    }
         @media only screen and (max-width: 340px) {
        .trigenda-wrapper {
            transform: scale(0.6) translateX(-25vw);
        }
    }
</style>
